import { Box, FlexBox } from '@dixa/lib-shared-habla';
import type { ConversationNodeMessengerMenu } from 'lib-shared-types-api';

import { sanitizeHtml } from 'utils/sanitizeHtml';

type Props = {
  node: ConversationNodeMessengerMenu;
};

export function RoutedThroughMessengerMenu({ node }: Props): JSX.Element {
  const sanitizedQuestion = node.question && (
    <Box
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(node.question, 'plainText'),
      }}
    />
  );
  return (
    <FlexBox>
      Menu ·{' '}
      {node.label ? (
        <>
          Selected&nbsp;
          <strong>{node.label}</strong>
        </>
      ) : (
        <>
          Question&nbsp;<strong>{sanitizedQuestion}</strong>;
        </>
      )}
    </FlexBox>
  );
}
